__webpack_require__.p = "/wp-content/plugins/movie-browser/app/build/";